/* eslint-disable */
angular.module('views')
  .controller('StandAloneViewCtrl', function ($scope, installationId,viewId,plants,filters) {
    $scope.installationId = installationId;
    $scope.selectedView = viewId;
    $scope.plants=plants;
    $scope.filters=filters;

  });
